module.exports = __webpack_public_path__ + "static/media/pinch01.6d68a538.webp";